import styled from 'styled-components';

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: var(--space-md);
`;

export const Label = styled.label`
  margin-bottom: var(--space-xs);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--gray-700);
`;

export const Input = styled.input`
  padding: var(--space-sm) var(--space-md);
  border: 1px solid var(--gray-300);
  border-radius: var(--border-radius-md);
  font-family: var(--font-family);
  font-size: var(--font-size-sm);
  background: var(--input-bg);
  color: var(--text-primary);
  transition: border-color var(--transition-fast);

  &:focus {
    outline: none;
    border-color: var(--primary-500);
    box-shadow: 0 0 0 3px rgba(147, 153, 1, 0.15);
  }

  &:disabled {
    background: var(--gray-100);
    color: var(--gray-500);
    cursor: not-allowed;
  }
`;

export const Select = styled.select`
  padding: var(--space-sm) var(--space-md);
  border: 1px solid var(--gray-300);
  border-radius: var(--border-radius-md);
  font-family: var(--font-family);
  font-size: var(--font-size-sm);
  background: var(--input-bg);
  color: var(--text-primary);
  transition: border-color var(--transition-fast);

  &:focus {
    outline: none;
    border-color: var(--primary-500);
    box-shadow: 0 0 0 3px rgba(147, 153, 1, 0.15);
  }
`;

export const Textarea = styled.textarea`
  padding: var(--space-sm) var(--space-md);
  border: 1px solid var(--gray-300);
  border-radius: var(--border-radius-md);
  font-family: var(--font-family);
  font-size: var(--font-size-sm);
  background: var(--input-bg);
  color: var(--text-primary);
  resize: vertical;
  min-height: 100px;
  transition: border-color var(--transition-fast);

  &:focus {
    outline: none;
    border-color: var(--primary-500);
    box-shadow: 0 0 0 3px rgba(147, 153, 1, 0.15);
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: var(--space-md);
  flex-wrap: wrap;

  ${FormGroup} {
    flex: 1;
    min-width: 200px;
  }
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: var(--space-md);
  margin-top: var(--space-xl);
`;
